import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Valeria U.', 'Martín R.', 'Carolina S.', 'Diego F.', 'Lucía M.', 'Andrés P.', 'Sofía B.', 'Ramiro L.', 'Camila T.', 'Federico G.'];
const CITIES = ['Paraná', 'Mendoza', 'Salta', 'Mar del Plata', 'Bahía Blanca', 'San Juan', 'Posadas', 'Resistencia', 'Corrientes', 'Bariloche', 'La Rioja', 'Santa Fe'];
export function FloatingProof() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentProof, setCurrentProof] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentProof({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 8 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 8000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 10000);
    // Then show every 30 seconds
    const intervalTimer = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-148">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-4 w-72 flex gap-3" data-id="element-149">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-150">
            <X size={16} data-id="element-151" />
          </button>

          <div className="flex-shrink-0 mt-1" data-id="element-152">
            <CheckCircle2 className="text-green-500" size={24} data-id="element-153" />
          </div>

          <div className="flex flex-col" data-id="element-154">
            <span className="text-xs font-bold text-gray-900 tracking-wide" data-id="element-155">
              COMPRA VERIFICADA
            </span>
            <span className="text-sm font-medium text-gray-800 mt-1" data-id="element-156">
              {currentProof.name} de {currentProof.city}
            </span>
            <span className="text-sm text-gray-600" data-id="element-157">
              compró Portugués 360 Elite 🇧🇷
            </span>
            <span className="text-xs text-gray-400 mt-1" data-id="element-158">
              hace {currentProof.time} minutos
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}